import RaffleInputFieldSearchComponent from "../../components/raffle/RaffleSearchComponent.tsx";
import {imageMap} from "../../images/imageMap.ts";

export default function RaffleSearchBoxComponent(props: { uid: string }) {
    return (
        <section className="content help-search">
            <div className="flex">
                <img className="chatbot-animate" src={imageMap.home.hibot_animated} alt="HiBot &ndash; Hipers lille hjælperchat."/>

                <div className="text-wrap">
                    <h2 className="heading heading--left heading--montserrat">Har du brug for hjælp?</h2>
                    <p>
                        <span className="hibot-red">Spørg HiBot</span> &ndash; så får du hurtigt svar!
                    </p>
                </div>
            </div>
            <RaffleInputFieldSearchComponent uid={props.uid}/>
        </section>
    )
}
